/**
 * MFA Service — frontend API client.
 *
 * Thin wrappers around apiCall. No state, no caching — components own state.
 * All endpoints use the HTTP-only session cookie except challenge/verify
 * which require the X-MFA-Token header (those live in mfaLoginApi later;
 * keep this file enrollment-only for separation).
 */
import { apiCall } from './apiUtils';

export const listFactors = async () => {
  return apiCall('/api/auth/mfa/factors', { method: 'GET' });
};

export const beginEnrollment = async (factorType) => {
  return apiCall('/api/auth/mfa/factors', {
    method: 'POST',
    data: { factor_type: factorType },
  });
};

export const activateFactor = async (factorId, proof) => {
  return apiCall(`/api/auth/mfa/factors/${encodeURIComponent(factorId)}/activate`, {
    method: 'POST',
    data: { proof },
  });
};

export const disableFactor = async (factorId, { currentPassword, proof }) => {
  return apiCall(`/api/auth/mfa/factors/${encodeURIComponent(factorId)}`, {
    method: 'DELETE',
    data: { current_password: currentPassword, proof },
  });
};

export const listTrustedDevices = async () => {
  return apiCall('/api/auth/mfa/trusted-devices', { method: 'GET' });
};

export const revokeTrustedDevice = async (id) => {
  return apiCall(`/api/auth/mfa/trusted-devices/${encodeURIComponent(id)}`, {
    method: 'DELETE',
  });
};

export const revokeAllTrustedDevices = async () => {
  return apiCall('/api/auth/mfa/trusted-devices', { method: 'DELETE' });
};
